(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	ngModule.filter('titlecase', function() {
	    return function(s) {
	        s = ( s === undefined || s === null ) ? '' : s;
	        return s.toString().toLowerCase().replace( /\b([a-z])/g, function(ch) {
	            return ch.toUpperCase();
	        });
	    };
	});

	ngModule.filter('tel', function () {
		return function (tel) {
			if (!tel) { return ''; }

			var value = tel.toString().trim().replace(/^\+/, '');

			if (value.match(/[^0-9]/)) {
				return tel;
			}

			var country, city, number;

			switch (value.length) {
				case 10: // +1PPP####### -> C (PPP) ###-####
				country = 1;
				city = value.slice(0, 3);
				number = value.slice(3);
				break;

				case 11: // +CPPP####### -> CCC (PP) ###-####
				country = value[0];
				city = value.slice(1, 4);
				number = value.slice(4);
				break;

				case 12: // +CCCPP####### -> CCC (PP) ###-####
				country = value.slice(0, 3);
				city = value.slice(3, 5);
				number = value.slice(5);
				break;

				default:
				return tel;
			}

			if (country == 1) {
				country = "";
			}

			number = number.slice(0, 3) + '-' + number.slice(3);

			return (country + " (" + city + ") " + number).trim();
		};
	});

	ngModule.filter('num', function() {
		return function(input) {
			return parseInt(input, 10);
		};
	});

    ngModule.filter('propertyName', function() {
        return function(propertyName) {

            var returnablePropertyName = '';

            switch (propertyName) {
                case 'customName':
                    returnablePropertyName = 'Name';
                break;
                case 'customNumber':
                    returnablePropertyName = 'Number';
                break;
                case 'color':
                    returnablePropertyName = 'Color';
                break;
                case 'sizes':
                    returnablePropertyName = 'Sizes';
                break;
                case 'inseam':
                    returnablePropertyName = 'Inseam';
                break;
                case 'fit':
                    returnablePropertyName = 'Fit';
                break;
                case 'options':
                    returnablePropertyName = 'Options';
                break;
                default:
                    return 'Unknown'

            }

            return returnablePropertyName;
        }
    });

    ngModule.filter('paymentMethodName', function() {
        return function(paymentMethodName) {

            var returnablePaymentMethodName = '';

            switch (paymentMethodName) {
                case 'credit':
                    returnablePaymentMethodName = 'Credit Card';
                break;
                case 'check':
                    returnablePaymentMethodName = 'Check';
                break;
                case 'org':
                    returnablePaymentMethodName = 'Organization/School';
                break;
                default:
                    return 'Unknown'

            }

            return returnablePaymentMethodName;
        }
    });

})();
